const STORAGE_KEY = 'ra-metagraph:user-papers';

/** Papers added by the visitor through the "Add Paper" flow, persisted to
 * this browser only (there's no backend — nothing is shared or uploaded). */
export function getStoredUserPapers() {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function persist(papers) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(papers));
  } catch {
    // Storage unavailable (private browsing, quota, etc.) — the paper still
    // lives in the in-memory cache for the rest of this session.
  }
}

export function addStoredUserPaper(record) {
  const papers = getStoredUserPapers();
  papers.push(record);
  persist(papers);
}

export function removeStoredUserPaper(userKey) {
  persist(getStoredUserPapers().filter((p) => p._userKey !== userKey));
}
